const doc = [({"name":"Cargo", "summary":"Cargo is Rust's build system", "icon":"ship", "repositories":[({"rust-lang/cargo":"E-Easy"})]})];
module.exports = doc.length <= 1 ? doc[0] : doc;